import React, { PureComponent } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import NoteTagList from '../theme/buttons/NoteTag';
import { connect } from 'react-redux';
import { setSessionVar } from '../../store/actions';

class SiteCard extends PureComponent {
  render() {
    let data = this.props.data || {};
    return (
      <div
        className={`side-menu-list-obj mx-0 ${this.props.focused ? 'focused' : ''}`}
        onClick={this.props.onClick}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
      >
        {this.props.onDeleteClick && (
          <i
            className="obj-action far fa-times-circle fa-pull-right"
            onClick={this.props.onDeleteClick}
          />
        )}
        {this.props.onEditClick && (
          <i className="obj-action far fa-edit fa-pull-right" onClick={this.props.onEditClick} />
        )}
        <div
          className="list-obj-inner-wrapper"
          style={{ borderLeftColor: this.props.color }}
          id={this.props.id}
        >
          <div className="obj-title">{data.name}</div>
          <div className="obj-data" style={{ marginTop: '9px' }}>
            {data.addressline1} {data.addressline2} <br />
            {data.city}, {data.statecode} {data.zip5}
          </div>
          <div
            className={'clickable-children'}
            onClick={() => this.props.setSiteModalSite(data)}
            style={{ marginTop: '.5em' }}
          >
            <NoteTagList notes={data.notes} addButton />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setSiteModalSite: (site) => dispatch(setSessionVar('siteNoteModalSite', site)),
});

export default connect(null, mapDispatchToProps)(SiteCard);
